// src/theme/typography.js

// We export a function that receives the base theme,
// so we can use theme.breakpoints in our styles
export default function getTypography(theme) {
  return {
    fontSize: 14, // Base font size set to 14px
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif', // new global font family
    button: {
      textTransform: "none",
      fontSize: "0.875rem", // 14px
      fontWeight: 500,
      lineHeight: 1.75,
    },
    // Headings
    h1: {
      fontSize: "1.875rem", // 3XL – 1.875rem/30px
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: "1.5rem", // 2XL – 1.5rem/24px
      fontWeight: 700,
      lineHeight: 1.3,
    },
    h3: {
      fontSize: "1.25rem", // XL – 1.25rem/20px
      fontWeight: 700,
      lineHeight: 1.3,
    },
    h4: {
      fontSize: "1.125rem", // LG – 1.125rem/18px
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h5: {
      fontSize: "1rem", // Base – 1rem/16px
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h6: {
      fontSize: "0.875rem", // SM – 0.875rem/14px
      fontWeight: 500,
      lineHeight: 1.4,
    },
    // Additional variants
    subtitle1: {
      fontSize: "1rem", // text-base – 1rem/16px
      fontWeight: 500,
      lineHeight: 1.5,
    },
    subtitle2: {
      fontSize: "0.875rem", // text-sm – 0.875rem/14px
      fontWeight: 500,
      lineHeight: 1.5,
    },
    body1: {
      fontSize: "1rem", // Base – 1rem/16px
      fontWeight: 400,
      lineHeight: 1.5,
    },
    body2: {
      fontSize: "0.875rem", // text-sm – 0.875rem/14px
      fontWeight: 400,
      lineHeight: 1.5,
    },
    caption: {
      fontSize: "0.75rem", // text-xs – 0.75rem/12px
      fontWeight: 400,
      lineHeight: 1.5,
    },
    overline: {
      fontSize: "0.75rem", // text-xs – 0.75rem/12px
      fontWeight: 500,
      lineHeight: 1.5,
      textTransform: "uppercase",
      letterSpacing: "0.08em",
    },
  };
}
